import React, {Component} from 'react'

class OutsideClickHandler extends Component {
  constructor(props) {
    super(props)
    this.wrapperRef = React.createRef()
    this.instanceId = props.instanceId
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = event => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.props.onClickOutside(false)
    }
  }

  render() {
    return <div ref={this.wrapperRef} className={`pop-warp-${this.instanceId}`} style={{display: 'inline-block'}}>{this.props.children}</div>
  }
}

export default OutsideClickHandler